import { TAG_DOMAIN_MAP as r } from "./index.es6.js";
function o(e, n) {
  return e.includes(n);
}
const i = (e) => e in r ? r[e] : o(Object.values(r), e) ? e : "INACTIVE", t = (e) => e == null ? void 0 : e.replace(/-/g, ""), s = (e) => ({
  ...e,
  tagDomain: i(e == null ? void 0 : e.tagDomain),
  tagGuid: t(e == null ? void 0 : e.tagGuid)
}), f = (e) => {
  const n = { ...e };
  return n.source && delete n.source, n.interestId && (n.interestId = t(n.interestId)), {
    ...n,
    tag: n.tag ? s(n.tag) : void 0
  };
};
function c() {
  if (typeof window < "u") {
    const e = window == null ? void 0 : window.localStorage.getItem("alertConfiguration");
    if (e)
      return !!JSON.parse(e).suspended;
  }
  return !1;
}
const l = (e) => e.length === 0;
export {
  s as formatForRequest,
  c as isAlertingSuspended,
  l as isEmpty,
  i as mapTagDomain,
  t as removeHyphens,
  f as transformTag
};
//# sourceMappingURL=index.es3.js.map
